export default "__VITE_ASSET__BYj3o78P__"